// frontend/src/components/commandpalette/KeyboardShortcutsHelp.jsx
// The keyboard shortcuts, as the app's popup (styles/dialog-form.css).

import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import './KeyboardShortcutsHelp.css';

const isMac = navigator.platform?.includes('Mac');
const mod = isMac ? '\u2318' : 'Ctrl';

const SHORTCUT_GROUPS = [
  {
    labelKey: 'shortcuts.groups.general',
    shortcuts: [
      { keys: [`${mod}+K`], labelKey: 'shortcuts.commandPalette' },
      { keys: [`${mod}+/`], labelKey: 'shortcuts.showShortcuts' },
    ],
  },
  {
    labelKey: 'shortcuts.groups.editing',
    shortcuts: [
      { keys: [`${mod}+S`], labelKey: 'shortcuts.saveChanges' },
    ],
  },
];

export default function KeyboardShortcutsHelp({ isOpen, onClose }) {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={onClose} className="dialog-form dialog-form--confirm">
      <DialogTitle>{t('shortcuts.title')}</DialogTitle>
      <DialogContent>
        {SHORTCUT_GROUPS.map((group) => (
          <div key={group.labelKey} className="ksh-group">
            <h3 className="ksh-group-label">{t(group.labelKey)}</h3>
            <div className="ksh-list">
              {group.shortcuts.map((sc) => (
                <div key={sc.labelKey} className="ksh-row">
                  <span className="ksh-label">{t(sc.labelKey)}</span>
                  <span className="ksh-keys">
                    {sc.keys.map((k) => (
                      <kbd key={k} className="ksh-kbd">{k}</kbd>
                    ))}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
  );
}
